import styled from 'styled-components';
import { Styling } from '../../../../../constants';

export const ProgressContainer = styled.div`
  height: ${Styling.DEFAULT_LINEAR_PROGRESS_HEIGHT}px;
`;
